"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationPanelBody = void 0;
exports.getIntegrationPanel = getIntegrationPanel;

var _preact = require("preact");

var _PanelItems = require("../PanelItems");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var IntegrationPanelBody = function IntegrationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      isSettingEnabled = _ref.isSettingEnabled,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      _onSettingChanged = _ref.onSettingChanged,
      showActionButtons = _ref.showActionButtons,
      communityArticleLink = _ref.communityArticleLink,
      description = _ref.description,
      toggleLabel = _ref.toggleLabel,
      additionalInputFields = _ref.additionalInputFields,
      integrationStatus = _ref.integrationStatus,
      storedIsSettingEnabled = _ref.storedIsSettingEnabled,
      isLoading = _ref.isLoading,
      additionalHelpTextBelowToggle = _ref.additionalHelpTextBelowToggle,
      hasUnsavedChanges = _ref.hasUnsavedChanges;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)("div", {
    className: "panel-body-instructions"
  }, description), isInstalled && (0, _preact.h)(_PanelItems.ToggleWithLabel, {
    label: toggleLabel,
    isToggleEnabled: isSettingEnabled,
    onSettingChanged: function onSettingChanged() {
      return _onSettingChanged(!isSettingEnabled);
    }
  }), communityArticleLink && (0, _preact.h)("div", null, (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "Learn more about this integration",
    url: communityArticleLink,
    isExternalLinkForToggle: false
  })), isInstalled && additionalInputFields, isInstalled && storedIsSettingEnabled && additionalHelpTextBelowToggle && (0, _preact.h)("div", {
    className: "help-text-wrapper below-toggle"
  }, additionalHelpTextBelowToggle, " "), integrationStatus, showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    isLoading: isLoading,
    isPrimaryDisabled: hasUnsavedChanges !== true
  }));
};

exports.IntegrationPanelBody = IntegrationPanelBody;

function getIntegrationPanel(props) {
  var isInstalled = props.isInstalled,
      isSettingEnabled = props.isSettingEnabled,
      title = props.title,
      imageFromName = props.imageFromName,
      imageToName = props.imageToName,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onSettingChanged2 = props.onSettingChanged,
      showActionButtons = props.showActionButtons,
      toggleLabel = props.toggleLabel,
      communityArticleLink = props.communityArticleLink,
      description = props.description,
      storedIsSettingEnabled = props.storedIsSettingEnabled,
      hasUnsavedChanges = props.hasUnsavedChanges,
      _onClickPanel = props.onClickPanel,
      customClass = props.customClass,
      additionalHelpText = props.additionalHelpText,
      additionalHelpTextBelowToggle = props.additionalHelpTextBelowToggle,
      integrationStatus = props.integrationStatus,
      additionalInputFields = props.additionalInputFields,
      isLoading = props.isLoading;
  return {
    title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderTitle, {
      isInstalled: isInstalled,
      storedIsSettingEnabled: storedIsSettingEnabled,
      title: title,
      imageFromName: imageFromName,
      imageToName: imageToName
    }),
    body: (0, _preact.h)(IntegrationPanelBody, {
      isInstalled: isInstalled,
      isSettingEnabled: isSettingEnabled,
      onSettingChanged: function onSettingChanged() {
        return _onSettingChanged2(!isSettingEnabled);
      },
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      showActionButtons: showActionButtons,
      toggleLabel: toggleLabel,
      communityArticleLink: communityArticleLink,
      description: description,
      additionalHelpText: additionalHelpText,
      additionalHelpTextBelowToggle: additionalHelpTextBelowToggle,
      integrationStatus: integrationStatus,
      storedIsSettingEnabled: storedIsSettingEnabled,
      additionalInputFields: additionalInputFields,
      isLoading: isLoading,
      hasUnsavedChanges: hasUnsavedChanges
    }),
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: "integration__panel ".concat(customClass !== null && customClass !== void 0 ? customClass : ''),
    onClickPanel: function onClickPanel(selectedPanel) {
      return _onClickPanel(selectedPanel);
    }
  };
}